module.exports = __webpack_public_path__ + "img/title.36f26f34.png";